import { Injectable } from '@angular/core';
import { PwaPushNotificationsUserSettings } from './pwa-push-notifications-user-settings.type';
import { LocalStorageCommonService } from '../local-storage/local-storage-common.service';

@Injectable({
    providedIn: 'root',
})
export class PwaPushNotificationsLocalStorageService {
    private readonly KEY_PWA_PUSH_NOTIFICATIONS_USER_SETTINGS = 'pwaPushNotificationsUserSettings';
    public constructor(private readonly localStorageCommonService: LocalStorageCommonService) {}

    public async savePwaPushNotificationsUserSettingsAsync(settings: PwaPushNotificationsUserSettings): Promise<void> {
        return this.localStorageCommonService.storageSetAsync(this.KEY_PWA_PUSH_NOTIFICATIONS_USER_SETTINGS, settings);
    }

    public async getPwaPushNotificationsUserSettingsAsync(): Promise<PwaPushNotificationsUserSettings | undefined> {
        return this.localStorageCommonService.storageGetAsync<PwaPushNotificationsUserSettings>(
            this.KEY_PWA_PUSH_NOTIFICATIONS_USER_SETTINGS,
        );
    }
}
